import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  AppScenariosAppointmentListAllAppointmentsApplicationPayloadAppointmentInResponse,
  AppointmentMemberInfo
} from '../types/apiGeneratedTypes';

interface AppointmentTestResultType {
  appointmentId: number;
  memberData: AppointmentMemberInfo | null;
}

export interface AppointmentsSliceState {
  appointmentsList: AppScenariosAppointmentListAllAppointmentsApplicationPayloadAppointmentInResponse[];
  totalCount: number;
  limit: number;
  isDeleteModalOpened: boolean;
  isEditModalOpened: boolean;
  appointmentTestResult: AppointmentTestResultType | null;
  appointmentIdToEdit: number | null;
}

export const initialState: AppointmentsSliceState = {
  appointmentsList: [],
  totalCount: 0,
  limit: 10,
  isDeleteModalOpened: false,
  isEditModalOpened: false,
  appointmentTestResult: null,
  appointmentIdToEdit: null
};

const appointmentsSlice = createSlice({
  name: 'appointments',
  initialState,
  reducers: {
    setAppointmentsList(
      state,
      action: PayloadAction<
        AppScenariosAppointmentListAllAppointmentsApplicationPayloadAppointmentInResponse[]
      >
    ) {
      state.appointmentsList = action.payload;
    },
    setAppointmentsTotalCount(state, action: PayloadAction<number>) {
      state.totalCount = action.payload;
    },
    setAppointmentsListAppend(
      state,
      action: PayloadAction<
        AppScenariosAppointmentListAllAppointmentsApplicationPayloadAppointmentInResponse[]
      >
    ) {
      state.appointmentsList = [
        ...(state.appointmentsList || []),
        ...action.payload
      ];
    },
    changeDeleteModalVisibility(state, action: PayloadAction<boolean>) {
      state.isDeleteModalOpened = action.payload;
    },
    changeEditModalVisibility(state, action: PayloadAction<boolean>) {
      state.isEditModalOpened = action.payload;
    },
    changeShowAppointmentTestResult(
      state,
      action: PayloadAction<AppointmentTestResultType | null>
    ) {
      state.appointmentTestResult = action.payload;
    },
    setAppointmentIdToEdit(state, action: PayloadAction<number | null>) {
      state.appointmentIdToEdit = action.payload;
    }
  }
});

export const {
  setAppointmentsList,
  setAppointmentsListAppend,
  setAppointmentsTotalCount,
  changeDeleteModalVisibility,
  changeEditModalVisibility,
  changeShowAppointmentTestResult,
  setAppointmentIdToEdit
} = appointmentsSlice.actions;
export default appointmentsSlice.reducer;
